export default "__VITE_ASSET__zoxp06O0__"